export const packageIdentity = Object.freeze({
    name: "@gordonland/world-format",
    stage: "p0-public-contract",
});
export { createWorldFormatKernelV1 } from "./kernel.js";
export { createWorldFormatCodecFactoryV1 } from "./codec.js";
export { BLOCK_CATALOG_V1, PLACEABLE_BLOCK_IDS_V1, WORLD_FORMAT_V1, } from "./contracts.js";
